<template>
  <div>
    <div class="checkbox-container">
      <v-checkbox
        v-if="withonine"
        v-model="is_online"
        @change="$emit('isOnlineChange', $event || 0)"
        name="activity_isonline"
        id="activity_isonline"
        :value="1"
        :label="trans('Is this activity online')"
      ></v-checkbox>
      <v-checkbox
        v-model="hasFlexibleDates"
        @change="$emit('hasFlexibleDates', $event || 0)"
        name="activity_hasFlexibleDates"
        id="activity_hasFlexibleDates"
        :value="1"
        :label="trans('Has flexible dates?')"
      ></v-checkbox>
    </div>

    <div v-if="!is_online">
      <vuetify-google-autocomplete
        v-if="currentLocation"
        ref="address"
        id="map"
        @placechanged="getAddressData"
        :country="tenantId"
        types="['establishment','address']"
        :currentLocation="currentLocation"
      ></vuetify-google-autocomplete>

      <vuetify-google-autocomplete
        v-if="addnew"
        ref="address"
        id="map"
        :placeholder="trans('Please type your address')"
        v-on:placechanged="getAddressData"
        :country="tenantId"
        types="['establishment','address']"
      ></vuetify-google-autocomplete>

      <v-select
        v-model="selectedCity"
        :label="trans('City')"
        name="city"
        :items="cites"
        item-text="name"
        item-value="id"
        outlined
        dense
        @change="$emit('cityChange', $event)"
      >
        <template slot="item" slot-scope="data">
          {{ trans(data.item['name']) }}
        </template>
      </v-select>
      <v-select
        v-model="selectedDistrict"
        :label="trans('District')"
        name="district"
        :items="districts"
        item-text="name"
        item-value="id"
        outlined
        dense
        @change="$emit('districtChange', $event)"
      >
        <template slot="item" slot-scope="data">
          {{ trans(data.item['name']) }}
        </template>
      </v-select>

      <input type="hidden" name="lat" :value="address.latitude" />
      <input type="hidden" name="long" :value="address.longitude" />
    </div>
  </div>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import Vue from 'vue';

export default {
  components: { VueGoogleAutocomplete },
  props: [
    'cites',
    'districts',
    'location',
    'addnew',
    'withonine',
    'isonline',
    'hasFlexibleDates',
  ],
  data: function () {
    return {
      address: { latitude: '', longitude: '' },
      selectedCity: '',
      selectedDistrict: '',
      cityDistricts: [],
      currentLocation: null,
      is_online: this.isonline ? this.isonline : 0,
      hasFlexibleDates: this.hasFlexibleDates,
    };
  },

  mounted() {
    // To demonstrate functionality of exposed component functions
    // Here we make focus on the user input
    //this.$refs.address.focus();
    if (this.location != null) {
      this.currentLocation = this.location.address;
      this.address = {
        latitude: this.location.lat,
        longitude: this.location.long,
      };
      this.selectedCity = parseInt(this.location.city_id);
      this.selectedDistrict = parseInt(this.location.district_id);
      this.updateDistrict();
    }
  },

  methods: {
    getAddressData: function (addressData, placeResultData, id) {
      this.address = addressData;
      this.$emit('addressChange', {
        formattedAddress: placeResultData.formatted_address,
        lat: addressData.latitude,
        long: addressData.longitude,
      });

      //get city from google
      var city =
        addressData.administrative_area_level_2 || addressData.locality;
      var district = addressData.sublocality_level_1;

      //find city id from cities props

      this.cites.forEach((item) => {
        // baki
        if (item.translated == city || item.name === city) {
          //baku , baki
          return (this.selectedCity = item.id);
        }
      });

      //find district id from districts props
      this.districts.forEach((item) => {
        if (item.translated == district || item.name == district) {
          this.selectedDistrict = item.id;
        }
      });

      this.$emit('cityChange', this.selectedCity);
      this.$emit('districtChange', this.selectedDistrict);
      this.updateDistrict();
      //this.selectedCity = addressData.administrative_area_level_1;
    },
    updateDistrict: function () {
      //empty district
      this.cityDistricts = [];

      //find district id from districts props
      this.districts.forEach((item) => {
        if (item.city_id == this.selectedCity) {
          this.cityDistricts.push(item);
        }
      });
    },
  },
  computed: {
    tenantId() {
      return window.tenant;
    },
  },
};
</script>


<style lang="css" scoped>
.checkbox-container {
  display: flex;
  gap: 10px;
}
</style>